import type { ReactNode } from "react"

export function pluralize<T extends ReactNode>(
  count: number,
  singular: T,
  plural: T,
): T {
  return count <= 1 ? singular : plural
}
